import { render } from "./MyProspectingSidebarElement.vue?vue&type=template&id=6d42f878&scoped=true"
import script from "./MyProspectingSidebarElement.vue?vue&type=script&lang=js"
export * from "./MyProspectingSidebarElement.vue?vue&type=script&lang=js"

import "./MyProspectingSidebarElement.vue?vue&type=style&index=0&id=6d42f878&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FMyProspectingSidebarElement.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/elements/my-prospecting-sidebar-element.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FMyProspectingSidebarElement.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d42f878"]])

export default __exports__